import styles from './radioField.module.css'
import { Option } from '../../types'
import { useEffect, useState } from 'react'
import { firstItem } from '../../../../../utils/listUtils'
import { O } from '../../../state/types'

type Props = {
    id: string
    defaultValue?: string
    value?: string,
    options: Option[]
    disabled?: boolean
    disabledOptions?: string[]
    // Custom content for an option label (e.g. part of it in bold); by default the option label text
    renderLabel?: (option: Option) => React.ReactNode
    onChange?: (value?: string) => void
}

export const RadioField = (props: Props) => {
    const { id, defaultValue, value, options, disabled, disabledOptions, renderLabel, onChange } = props

    const [stateValue, setStateValue] = useState<O<string>>(defaultValue || firstItem(options)?.value)

    useEffect(() => {
        setStateValue(value)
    }, [value])

    const optionId = (index: number) => `${id}-${index}`

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target?.value
        setStateValue(newValue)
        onChange && onChange(newValue)
    }

    return (
        <div className={styles.container}>
            {options.map((option, index) => {
                return (
                    <div key={option.value} className="form-check">
                        <input
                            type="radio"
                            name={id}
                            id={optionId(index)}
                            value={option.value}
                            checked={stateValue === option.value}
                            disabled={disabled || disabledOptions?.includes(option.value)}
                            className={`form-check-input ${styles.option}`}
                            onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor={optionId(index)}>
                            {renderLabel ? renderLabel(option) : option.label}
                        </label>
                    </div>
                )
            })}
        </div>
    )
}
